import React, {useEffect, useRef, useState} from 'react';
import {AgyleTable, createAgyleTableColumn} from '../../table/AgyleTable';
import _ from 'lodash';
import moment from 'moment/moment';
import config from '../../../app/config';
import AgyleDialog from '../../modal/agyleDialog';
import {useDispatch, useSelector} from "react-redux";
import {currentMap, updateBedasStatus} from '../../../store/reducers/ward';
import MessageBox from "../../../util/messageBox";
import useOpenState from "../../../hooks/useOpenState";
import {useTranslation} from "react-i18next";
import AgyleButton from "../../ui/buttons/agyleButton";
import BedasSessionsManager from "./bedasSessionsManager";

export const BedasSessionsTable = (props) => {
  const {sessions} = props;
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const hospital = useSelector(currentMap);

  const [isBlockModalOpen, openBlockModal, closeBlockModal] = useOpenState(false);
  const [isConfirmOpen, openConfirm, closeConfirm] = useOpenState(false, false);
  const [dataTable, setDataTable] = useState([]);
  const sessionRef = useRef(null)

  const columnsTable = [
    createAgyleTableColumn("active", "Active", 1, "active", "string", "", "medium", "left", true, true, '5%', null),
    createAgyleTableColumn("locked", "Locked", 2, "locked", "string", "", "medium", "left", true, true, '5%', null),
    createAgyleTableColumn("lockedReason", "Lock Reason", 3, "lockedReason", "string", "", "medium", "left", true, true, '10%', null),
    createAgyleTableColumn("startDate", "Session Start Date", 4, "startDate", "string", "", "medium", "left", true, true, '10%', 140),
    createAgyleTableColumn("startTime", "Session Start Time", 5, "startTime", "string", "", "medium", "left", true, true, '10%', 140),
    createAgyleTableColumn("endDate", "Session End Date", 6, "endDate", "string", "", "medium", "left", true, true, '10%', null),
    createAgyleTableColumn("endTime", "Session End Time", 7, "endTime", "string", "", "medium", "left", true, true, '10%', null),
    createAgyleTableColumn("daysOfWeek", "Days of Week", 8, "daysOfWeek", "string", "", "medium", "left", true, true, '15%', null),
    createAgyleTableColumn("interval", "Time Interval", 9, "timeInterval", "string", "", "medium", "left", true, true, '10%', null),
    createAgyleTableColumn("action", "Action", 10, null, "action", "notSort", "medium", "left", true, true, '10%', null, [], !props.disabled),
  ];

  useEffect(() => {
    const data = [];
    _.forEach(sessions, session => {
      const switchSessionIntervalType = (session) => {
        let type = session?.intervalType;
        const isCustom = session?.customInterval;

        if (isCustom) {
          type = session?.customIntervalType;
        }

        switch (type) {
          case 'day':
            return isCustom ? `Every ${session?.customIntervalNumber} Day` : 'Every Day';
          case 'week':
            return isCustom ? `Every ${session?.customIntervalNumber} Week` : 'Every Week';
          // return 'Every Week';
          case '2week':
            return isCustom ? `Every ${session?.customIntervalNumber} Two Weeks` : 'Every Two Weeks';
          // return 'Every Two Weeks';
          case '3week':
            return isCustom ? `Every ${session?.customIntervalNumber} Three Weeks` : 'Every Three Weeks';
          // return 'Every Three Weeks';
          case '4week':
            return isCustom ? `Every ${session?.customIntervalNumber} Four Weeks` : 'Every Four Weeks';
          case 'month':
            return isCustom ? `Every ${session?.customIntervalNumber} Month` : 'Every Month';
          default:
            return 'Every Week';
        }
      }

      const getDaysOfWeek = (session) => {
        if (_.isEmpty(session?.daysOfWeek)) return '-';

        const days = _.map(session?.daysOfWeek, day => {
          return moment().isoWeekday(parseInt(day, 10)).format('ddd');
        });

        return days.join(', ');
      };

      const getBoolean = (field) => session?.[field] ? "Yes" : "No";

      data.push({
        id: session?.sessionId,
        active: getBoolean('active'),
        locked: getBoolean('locked'),
        lockedReason: session?.lockedReason || '-',
        startDate: moment(session?.startDate).format(config.defaultDateFormat),
        startTime: moment(session?.startDate).format(config.defaultTimeFormat),
        endDate: moment(session?.endDate).format(config.defaultDateFormat),
        endTime: moment(session?.endDate).format(config.defaultTimeFormat),
        timeInterval: switchSessionIntervalType(session),
        daysOfWeek: getDaysOfWeek(session),
      });
    });
    setDataTable(data);
  }, [sessions]);

  const editSession = (singleSession) => {
    const session = _.find(sessions, {sessionId: singleSession.id});
    if (session) {
      props.onEdit(session);
    } else {
      console.log("not found");
    }
  }

  const openDeleteSessionConfirmation = (singleSession) => {
    const session = _.find(sessions, {sessionId: singleSession.id});
    if (session) {
      openConfirm();
      sessionRef.current = session;
    }
  }

  const acceptDeleteSession = () => {
    if (sessionRef.current) {
        dispatch(updateBedasStatus(hospital?.hospitalId, sessionRef.current, handleCloseConfirm, hospital, 'delete'));
    }
  }

  const handleCloseConfirm = () => {
    closeConfirm();
    sessionRef.current = null;
  }

  const componentLabel = config?.appointmentNotBedasLabel ? 'Appointment' : 'Follow Up';

  const buttons = () => {
    let buttonList = [];
    if (config?.bedasSessionManagementEnabled && !props.disabled) {
        buttonList.push(
            <AgyleButton
                key="block"
                onClick={() => {
                    openBlockModal();
                }}
                variant="contained"
                color="primary"
            >
              {t(`Add ${componentLabel} Session`)}
            </AgyleButton>
        );
    }

    return buttonList
  }

  return (<>
    <AgyleDialog
      onClose={props.onClose}
      open={props.open}
      title={`${componentLabel} Session List`}
      width={"lg"}
      fullWidth={true}
      closeButtonOnHeader
      disableSave
      blur={10}
      buttons={buttons()}
    >
        <>
            <AgyleTable
              columns={columnsTable}
              data={dataTable}
              editItem={editSession}
              deleteItem={openDeleteSessionConfirmation}
              disableFilter
            />

            <MessageBox
                title={t(`Delete ${componentLabel} Session`)}
                haveAccept={{yes: t("Submit"), no: t("Close")}}
                warning
                onAccept={acceptDeleteSession}
                onClose={handleCloseConfirm}
                message={t(`Are you sure you want to delete this ${componentLabel} session?`)}
                open={isConfirmOpen}
            />

        </>
    </AgyleDialog>
        <BedasSessionsManager
            open={isBlockModalOpen}
            onClose={closeBlockModal}
        />
  </>
  )
}